import httpService from './http.service';

const regionEndPoint = "order/";
const orderEndPoint = "order/";
const orderChangeEndPoint = "order/";
const orderStatusEndPoint = "bill/"
const billEndPoint = "bill/";



const shopService = {

   getRegionsByShopName: async (region) => {
      const { data } = await httpService.get(`${regionEndPoint}${region}/region/`);
      return data;
   },
   receiveOrderByShopAndRegion: async (shop, params) => {
      const { data } = await httpService.get(`${orderEndPoint}${shop}/`, {
         ...params,
      });
      return data;
   },
   changeOrder: async (body) => {
      const { data } = await httpService.post(`${orderChangeEndPoint}${body?.shopType}/change/`, body);
      return data;
   },
   receiveOrderStatus: async (params) => {
      const { data } = await httpService.get(`${orderStatusEndPoint}${params?.shopType}/status/`, {
         params
      });
      return data;
   },
   generateBill: async (body) => {
      const { data } = await httpService.post(`${billEndPoint}${body?.shopType}/generate/`, body);
      return data;
   },
   requestAccountLink: async ({ shopType, email }) => {
      const { data } = await httpService.post(`account-link/${shopType}/request`, { email });
      return data;
   },

}

export default shopService;
